/*
 * SimpleTableHeader.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

import { localization } from '../../../config/localize/localizable'

const SimpleTableCells = ({ items, hints, className }) => {
    return (
        <>
            {items &&
                items.map((item, index) => {
                    return (
                        <td title={`${hints != null ? hints[index] ?? item : ''}`} key={index} className={className}>
                            {item}
                        </td>
                    )
                })}
        </>
    )
}

export default SimpleTableCells
